import { Modal } from 'react-bootstrap';
import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons/faChevronLeft';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';

import withComponentName from '../../../../../decorators/withComponentName';

import Styles from '../styles.module.scss';

const cx = classNames.bind(Styles);

const FiltersMobileModal = ({
  openFilter,
  handleCloseModal,
  width,
  children,
}) => (
  <Modal
    show={openFilter}
    onHide={handleCloseModal}
    dialogClassName={Styles['filters-presentations-modal-dialog']}
    className={Styles['filters-presentations-mobile-modal']}
    centered
  >
    {width <= 767 && (
      <div
        className={cx('dropdown_back')}
        onClick={handleCloseModal}
      >
        <FontAwesomeIcon icon={faChevronLeft} />
        <span>Back</span>
      </div>
    )}
    <FontAwesomeIcon
      className={cx('dropdown_close')}
      icon={faXmark}
      onClick={handleCloseModal}
    />
    {children}
  </Modal>
);

export default withComponentName(FiltersMobileModal);
